"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boundarySection = void 0;
const types_1 = require("../../../types");
exports.boundarySection = {
    label: "form.boundaryTechnical.label",
    name: "boundary",
    subline: "form.boundaryTechnical.subline",
    info: "form.boundaryTechnical.info",
    isGroup: true,
    groups: [
        { name: "connection", label: "form.boundaryTechnical.group.connection" },
        {
            name: "environmental",
            label: "form.boundaryTechnical.group.environmental",
        },
        { name: "additional", label: "form.boundaryTechnical.group.additional" },
    ],
    fields: [
        {
            name: "electrical_voltage",
            label: "form.boundary.electrical_voltage",
            type: types_1.FormFieldType.short,
            groupName: "connection",
            placeholder: "form.boundary.placeholder.electrical_voltage",
        },
        {
            name: "power_consumption",
            label: "form.boundary.power_consumption",
            type: types_1.FormFieldType.short,
            groupName: "connection",
            placeholder: "form.boundary.placeholder.power_consumption",
        },
        {
            name: "grid_protection",
            label: "form.boundary.grid_protection",
            type: types_1.FormFieldType.short,
            groupName: "connection",
            placeholder: "form.boundary.placeholder.grid_protection",
        },
        {
            name: "hydraulic_max",
            label: "form.boundary.hydraulic_max",
            type: types_1.FormFieldType.input,
            groupName: "connection",
            placeholder: "form.boundary.placeholder.hydraulic_max",
        },
        {
            name: "pneumatic_max",
            label: "form.boundary.pneumatic_max",
            type: types_1.FormFieldType.input,
            groupName: "connection",
            placeholder: "form.boundary.placeholder.pneumatic_max",
        },
        {
            name: "temperature",
            label: "form.boundary.temperature",
            type: types_1.FormFieldType.input,
            groupName: "environmental",
            placeholder: "form.boundary.placeholder.temperature",
            required: true,
        },
        {
            name: "humidity",
            label: "form.boundary.humidity",
            type: types_1.FormFieldType.input,
            groupName: "environmental",
            placeholder: "form.boundary.placeholder.humidity",
        },
        {
            name: "usage_environment",
            label: "form.boundary.usage_environment",
            type: types_1.FormFieldType.full,
            groupName: "environmental",
            placeholder: "form.boundary.placeholder.usage_environment",
        },
        {
            name: "load_limit",
            label: "form.boundary.load_limit",
            type: types_1.FormFieldType.short,
            groupName: "additional",
            placeholder: "form.boundary.placeholder.load_limit",
        },
        {
            name: "noise_emission",
            label: "form.boundary.noise_emission",
            type: types_1.FormFieldType.short,
            groupName: "additional",
            placeholder: "form.boundary.placeholder.noise_emission",
        },
        {
            name: "weight",
            label: "form.boundary.weight",
            type: types_1.FormFieldType.short,
            groupName: "additional",
            placeholder: "form.boundary.placeholder.weight",
            required: true,
        },
    ],
};
exports.default = exports.boundarySection;
